<template>
  <el-card class="box-card">
    <el-steps :active="active" align-center process-status="finish">
      <el-step title="用户基本资料"></el-step>
      <el-step title="银行基本信息"></el-step>
      <el-step title="提交资料"></el-step>
    </el-steps>

    <div class="card-contetn">
      <el-form
        v-if="active==0"
        :model="dataForm1"
        status-icon
        :rules="rules"
        ref="dataForm1"
        label-width="120px"
        class="demo-ruleForm"
        style="width:500px;margin:30px auto"
      >
        <el-form-item label="登录账户" prop="username">
          <el-input type="type" v-model="dataForm1.username" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="登录密码" prop="password">
          <el-input type="password" v-model="dataForm1.password" autocomplete="off"></el-input>
        </el-form-item>
           <el-form-item label="确认密码" prop="password2">
          <el-input type="password" v-model="dataForm1.password2" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="mobile">
          <el-input v-model="dataForm1.mobile"></el-input>
        </el-form-item>
        <el-form-item label="姓名" prop="realName">
          <el-input v-model="dataForm1.realName" maxlength="25"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="dataForm1.email" maxlength="50"></el-input>
        </el-form-item>
      </el-form>

      <el-form
        v-if="active==1"
        :model="dataForm2"
        status-icon
        :rules="rules"
        ref="dataForm2"
        label-width="120px"
        class="demo-ruleForm"
        style="width:500px;margin:30px auto"
      >
        <el-form-item label="银行名称" prop="bankName">
          <el-input type="type" v-model="dataForm2.bankName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="注册地址" prop="registeredAddress">
          <el-input v-model="dataForm2.registeredAddress" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="联系人" prop="contacts">
          <el-input v-model="dataForm2.contacts"></el-input>
        </el-form-item>
        <el-form-item label="联系方式" prop="contactNumber">
          <el-input v-model="dataForm2.contactNumber"></el-input>
        </el-form-item>
        <el-form-item label="联系地址" prop="contactAddress">
          <el-input v-model="dataForm2.contactAddress"></el-input>
        </el-form-item>
        <el-form-item label="logo" prop="logo">
          <el-upload
            v-loading="loading"
            class="avatar-uploader"
            :action="actions"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :on-progress="handleProgress"
          >
            <img v-if="dataForm2.logoUrl" :src="dataForm2.logoUrl" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon">
              <div>上传照片</div>
            </i>
          </el-upload>
        </el-form-item>
      </el-form>

      <div v-if="active==2&&info.tanantState==1" class="submitCheck">
        <i class="el-icon-success icon-style"></i>
        <h3>资料提交成功</h3>
        <p>请等待审核通知！</p>
      </div>
      <div v-else-if="active==2&&info.tanantState==3" class="submitCheck">
        <i class="el-icon-error icon-style" style="color:red"></i>
        <h3>审核失败，请修改资料重新提交！！</h3>
        <p>{{info.tanantRemark}}</p>
      </div>

      <div class="stepBtn" v-if="active!=2">
        <el-button @click="prevStep" v-if="active!=0">上一步</el-button>
        <el-button type="primary" @click="nextStep">下一步</el-button>
      </div>
      <div class="stepBtn check" v-else>
        <el-button @click="backHandle">返回</el-button>
        <el-button type="primary" @click="seeInfoHandle">{{info.tanantState==1?'查看资料':'修改资料'}}</el-button>
      </div>
    </div>
  </el-card>
</template>
<script>
import reg from "@/utils/regular.js";

export default {
  name: "mallRegister",
  data() {
    let checkuser = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入账户"));
      }
      if (!reg.userreg.test(value)) {
        callback(new Error("账号为6-18位任意组合"));
      }
      callback();
    };

    let checkPwd = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入账户密码"));
      }
      if (!reg.pwdreg.test(value)) {
        callback(new Error("密码为6-18位数字或字母组合"));
      }
      callback();
    };
    let checkPhone = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入手机号"));
      }
      if (!reg.phone.test(value)) {
        callback(new Error("请输入正确的手机号"));
      }
      callback();
    };
    let checkEmail = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入邮箱"));
      }
      if (!reg.email.test(value)) {
        callback(new Error("请输入正确的邮箱"));
      }
      callback();
    };

    var validateComfirmPassword = (rule, value, callback) => {
        if (value === "") {
          callback(new Error('确认密码不能为空'))
        } else if (value !== this.dataForm1.password) {
          callback(new Error('两次密码输入不一致'))
        } else {
          callback()
        }
      }

    return {
      info: {},
      loading: false,
      schoolImg: "",
      actions: process.env.VUE_APP_BASE_API + "/api/web/uploadFile/upload",
      rules: {
        username: [{ required: true, validator: checkuser, trigger: "blur" }],
        password: [{ required: true, validator: checkPwd, trigger: "blur" }],
        password2: [{ required: true, validator: validateComfirmPassword, trigger: "blur" }],


        mobile: [{ required: true, validator: checkPhone, trigger: "blur" }],
        realName: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        email: [{ required: true, validator: checkEmail, trigger: "blur" }],
        bankName: [
          { required: true, message: "请输入银行名称", trigger: "blur" }
        ],
        registeredAddress: [
          { required: true, message: "请输入注册地址", trigger: "blur" }
        ],
        contacts: [
          { required: true, message: "请输入联系人姓名", trigger: "blur" }
        ],
        contactNumber: [
          { required: true, message: "请输入联系方式", trigger: "blur" }
        ],
        contactAddress: [
          { required: true, message: "请输入联系地址", trigger: "blur" }
        ],
        logo: [{ required: true, message: "请上传logo", trigger: "blur" }]
      },
      dataForm1: {
        tenantCode: 99999,
        username: "",
        password: "",
        mobile: "",
        realName: "",
        email: "",
        id: ""
      },
      dataForm2: {
        tenantInformationId: "",
        registeredAddress: "",
        contacts: "",
        contactAddress: "",
        contactNumber: "",
        id: "",
        logo: "",
        bankName: "",
        tenantCode: 99999
      },
      active: 0,
      imageUrl: ""
    };
  },
  watch: {
    isEdit() {
      this.$refs.dataForm3.clearValidate();
    },
    $route(to) {
      this.approveId = to.query.approveId;
      if (this.active == 0)
        this.getBaseInfo(sessionStorage.getItem("tenantInformationId") || this.approveId);
    }
  },
  created() {
    if (this.$route.query.record) {
      this.active = this.$route.query.record * 1;
      this.approveId = this.$route.query.approveId;
    }
    if (this.active >= 2) this.isCheck()
    else if (this.active == 0 && sessionStorage.getItem("tenantInformationId")) this.getBaseInfo(sessionStorage.getItem("tenantInformationId"));
  },
  methods: {
    //审批
    isCheck() {
      this.$request
        .post("/approver-api/api/web/approvetenantinformation/check")
        .then(res => {
          console.log(res);
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          }
          this.info = res.data;
         if(res.data.approveRecordList.length>0){
           sessionStorage.setItem("tenantInformationId",res.data.approveRecordList[0].approveId)
             if(res.data.approveRecordList[1]){
          sessionStorage.setItem("bankId",res.data.approveRecordList[1].approveId)
             }
         }
        });
    },
    prevStep() {
      if (--this.active <= 0) this.active = 0;

      if (this.active == 0) {
        this.approveId = this.tenantInformationId
          ? this.tenantInformationId
          : this.approveId;
        this.$refs["dataForm2"].clearValidate();
      }

      this.$router.push({
        name: "openCardRegister",
        query: { record: this.active, approveId: this.approveId }
      });
    },
    nextStep() {
      switch (this.active) {
        case 0:
          this.dataValid("dataForm1", this.addOrUpdateBaseInfo);
          if (JSON.stringify(this.info) !== "{}") {
            this.getBankInfo(this.info.approveRecordList[1].approveId);
          }
          break;
        case 1:
          this.dataValid("dataForm2", this.addOrUpdataRevice);
          this.isCheck();
          break;
      }
    },
    dataValid(form, cb) {
      this.$refs[form].validate(valid => {
        if (valid) {
          cb();
        } else {
          return false;
        }
      });
    },
    //得到基本信息
    getBaseInfo(tenantInformationId) {
      this.$request
        .post(`/approver-api/api/web/approvetenantinformation/info`, {
          tenantInformationId
        })
        .then(res => {
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          }
          this.dataForm1 = {
            ...this.dataForm1,
            ...res.data,
            tenantCode: 99999
          };
        });
    },
    //得到银行信息
    getBankInfo(bankId) {
      this.$request
        .post(`/approver-api/api/web/approvebankinfo/info`, {
          bankId: bankId
        })
        .then(res => {
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          }
          this.dataForm2 = {
            ...this.dataForm2,
            ...res.data,
            tenantCode: 99999
          };
        });
    },
    //增加或者修改基本信息
    addOrUpdateBaseInfo() {
      this.$refs["dataForm1"].validate(vaild => {
        if (!vaild) {
          return false;
        }
        this.$request
          .post("/approver-api/api/web/approvetenantinformation/saveOrUpdate", {
            ...this.dataForm1
          })
          .then(res => {
            console.log(res);
            if (res.code !== 0) {
              return this.$message.error(res.msg);
            }
            this.dataForm2.tenantInformationId = res.data.tenantInformationId;
            this.tenantInformationId = res.data.tenantInformationId;
            console.log(this.tenantInformationId);
            sessionStorage.setItem("tenantInformationId",res.data.tenantInformationId)
            if (++this.active >= 3) this.active = 3;
          });
      });
    },
    //增加或者修改银行账号信息
    addOrUpdataRevice() {
      this.$refs["dataForm2"].validate(vaild => {
        if (!vaild) {
          return false;
        }
        this.$request
          .post("/approver-api/api/web/approvebankinfo/saveOrUpdate", {
            ...this.dataForm2,
            tenantInformationId: this.tenantInformationId
              ? this.tenantInformationId
              : this.approveId
          })
          .then(res => {
            console.log(res);
            if (res.code !== 0) {
              return this.$message.error(res.msg);
            }
            this.$router.push({name:"openCardRegister",query:{record:2}})
            // this.dataForm2.id = res.data.id;
            if (++this.active >= 3) this.active = 3;
          });
      });
    },
    handleAvatarSuccess(res) {
      this.dataForm2.logoUrl = res.data.url; //绝对路径
      this.dataForm2.logo = res.data.imageUrl; //相对路径
      this.rules.logo[0].required = false;
      this.loading = false;
    },
    handleProgress() {
      this.loading = true;
    },
    backHandle() {
      this.$router.push({name:"adminRegister"});
    },
    seeInfoHandle() {
      if (this.info.tanantState == 3) {
        this.active = 0;
        this.getBaseInfo(this.info.approveRecordList[0].approveId);
      } else {
        this.isCheck()
        setTimeout(()=>{
           this.$router.push({
          name: "bankInfo",
          query: { id:sessionStorage.getItem("bankId") || this.approveId }
        });
        },200)
       
      }
    }
  }
};
</script>
<style lang="less" scoped>
.el-card {
  .el-steps {
    padding: 20px;
  }
  .stepBtn {
    text-align: center;
  }

  .text {
    position: absolute;
    font-size: 12px;
    color: #ccc;
    top: 10px;
    right: -90px;
  }
  .otherText {
    top: 20px;
    left: -100px;
  }
  .submitCheck {
    text-align: center;
    .icon-style {
      color: green;
      display: block;
      font-size: 100px;
      margin: 0 auto;
    }
  }
  .card-contetn {
    height: 463px;
  }
}

.avatar-uploader {
  border: 1px dashed #ccc;
  height: 80px;
  width: 80px;
  text-align: center;

  /deep/ .el-upload--text {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 100%;
    }
  }
}
</style>